
export default function getWindowList(appModules) {
    const windowList = [
        {
            iconName: 'FabricPictureLibrary',
            title: 'Přepnout do mapového okna',
            windowName: 'map'
        }        
    ];

    if (appModules.indexOf('data') !== -1) {
        windowList.push({
            iconName: 'FabricFormLibrary',
            title: 'Přepnout do datového okna',
            windowName: 'data'
        });
    }

    return windowList;
}
